import React from "react";
import { ColumnsType } from "antd/es/table";
import {
  ItemProps,
  OrderInventoryProps,
  TransactionLineProps,
  TransactionProps,
  RoleProps,
  UserDataProps,
  ConnectionProps,
} from "../../interfaces/interfaces";
import { Button, Checkbox } from "antd";
import { EditFilled } from "@ant-design/icons";
import dayjs from "dayjs";

export const OrderTableColumns: ColumnsType<TransactionProps> = [
  {
    title: "OID",
    dataIndex: "OID",
    key: "OID",
  },
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Drilling Company",
    dataIndex: "DrillingCompany",
  },
  {
    title: "Rig Number",
    dataIndex: "RigNumber",
  },
  {
    title: "Serial Number",
    dataIndex: "SerialNumber",
  },
  {
    title: "PO #",
    dataIndex: "PurchaseOrderNo",
  },
  {
    title: "Estimate #",
    dataIndex: "EstimateNo",
  },
  {
    title: "Item",
    dataIndex: "ItemDetail",
    render: (params: ItemProps) => <>{params ? params.Name : ""}</>,
  },
  {
    title: "Status",
    dataIndex: "Status",
  },
  {
    title: "Connection",
    dataIndex: "ConnectionDetail",
    render: (params: ConnectionProps) => <>{params ? params.Name : ""}</>,
  },
  {
    title: "Date Received",
    dataIndex: "DateReceived",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
  },
  {
    title: "Date Repaired",
    dataIndex: "DateRepaired",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
  },
  {
    title: "Date Shipped",
    dataIndex: "DateShipped",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
  },
];

export const OrderLinesTableColumns: ColumnsType<TransactionLineProps> = [
  {
    title: "OID",
    dataIndex: "OID",
    key: "OID",
  },
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Item Name",
    dataIndex: "itemDetail",
    width: "10vw",
    render: (params) => <>{params && params.Name ? params.Name : ""}</>,
  },
  {
    title: "Item Qty",
    dataIndex: "ItemQty",
  },
  {
    title: "Quantity",
    dataIndex: "Quantity",
  },
];

export const ItemTableColumns: ColumnsType<ItemProps> = [
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Name",
    dataIndex: "Name",
  },
];

export const ConnectionTableColumns: ColumnsType<ConnectionProps> = [
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Name",
    dataIndex: "Name",
  },
];

export const RoleTableColumns: ColumnsType<RoleProps> = [
  {
    title: "Name",
    dataIndex: "Name",
  },
  {
    title: "Is Administrative",
    dataIndex: "IsAdministrative",
    align: "center",
    render: (params) => <Checkbox checked={params} />,
  },
  {
    title: "Can Edit Model",
    dataIndex: "CanEditModel",

    render: (params) => <Checkbox checked={params} />,
  },
];

export const UserTableColumns: ColumnsType<UserDataProps> = [
  {
    title: "Username",
    dataIndex: "UserName",
  },
  {
    title: "Is Active",
    dataIndex: "IsActive",
    align: "center",
    render: (params) => <Checkbox checked={params} />,
  },
];

export const ReportTableColumns: ColumnsType<TransactionProps> = [
  {
    title: "Drilling Co",
    dataIndex: "DrillingCompany",
    key: "DrillingCompany",
    fixed: "left",
    width: 120,
    className: "cell",
    // sorter: {
    //   compare: (a: OrderReport, b: OrderReport) => {
    //     if (a.DrillingCompany && b.DrillingCompany)
    //       return a.DrillingCompany.localeCompare(b.DrillingCompany);
    //   },
    //   multiple: 2,
    // },
  },
  {
    title: "Rig No",
    dataIndex: "RigNumber",
    key: "RigNumber",
    fixed: "left",
    width: "10%",
    filterSearch: true,
    filterMode: "tree",
    className: "cell",
    // sorter: {
    //   compare: (a: OrderReport, b: OrderReport) => {
    //     if (a.RigNumber && b.RigNumber)
    //       return a.RigNumber.localeCompare(b.RigNumber);
    //   },
    //   multiple: 3,
    // },
  },
  {
    title: "Serial No",
    dataIndex: "SerialNumber",
    key: "SerialNumber",
    fixed: "left",
    width: "10%",
    filterSearch: true,
    filterMode: "tree",
    className: "cell",
    // sorter: {
    //   compare: (a: OrderReport, b: OrderReport) => {
    //     if (a.SerialNumber && b.SerialNumber)
    //       return a.RigNumber.localeCompare(b.RigNumber);
    //   },
    //   multiple: 4,
    // },
  },
  {
    title: "PO",
    dataIndex: "PurchaseOrderNo",
    key: "PurchaseOrderNo",
    fixed: "left",
    width: "10%",
    filterSearch: true,
    filterMode: "tree",
    className: "cell",
  },
  {
    title: "Estimate No.",
    dataIndex: "EstimateNo",
    key: "EstimateNo",
    fixed: "left",
    width: "10%",
    filterSearch: true,
    filterMode: "tree",
    className: "cell",
  },
  {
    title: "Item",
    dataIndex: "ItemDetail",
    key: "Item",
    fixed: "left",
    width: "10%",
    className: "cell",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "0",
    fixed: "left",
    width: "10%",
    className: "cell",
    sorter: {
      compare: (a: TransactionProps, b: TransactionProps) => {
        return a.Status.localeCompare(b.Status);
      },
      multiple: 1,
    },
  },
  {
    title: "Connection",
    dataIndex: "ConnectionDetail",
    key: "ConnectionDetail",
    fixed: "left",
    width: "10%",
    className: "cell",
  },
  {
    title: "Date Received",
    dataIndex: "DateReceived",
    key: "DateReceived",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
    fixed: "left",
    width: "10%",
    className: "cell",
    sorter: {
      compare: (a: TransactionProps, b: TransactionProps) => {
        return dayjs(a.DateReceived).isBefore(dayjs(b.DateReceived)) as any;
      },
      multiple: 2,
    },
  },
  {
    title: "Date Repaired",
    dataIndex: "DateRepaired",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
    key: "DateRepaired",
    fixed: "left",
    width: "10%",
    className: "cell",
    sorter: {
      compare: (a: TransactionProps, b: TransactionProps) => {
        return dayjs(a.DateRepaired).isBefore(dayjs(b.DateRepaired));
      },
      multiple: 3,
    },
  },
  {
    title: "Date Shipped",
    dataIndex: "DateShipped",
    render: (params) => <>{params ? dayjs(params).format("MM/DD/YYYY") : ""}</>,
    key: "DateShipped",
    fixed: "left",
    width: "10%",
    className: "cell",
    sorter: {
      compare: (a: TransactionProps, b: TransactionProps) => {
        return dayjs(a.DateShipped).isBefore(dayjs(b.DateShipped));
      },
      multiple: 4,
    },
  },
];
